import { useInfiniteQuery } from "@tanstack/react-query";
import { getAchievementPosts } from "../services/achievements.service";
import { entityKeys } from "../queryKeys";
import { AchievementPostsResponse } from "../types/achievements.types";

const ACHIEVEMENT_POSTS_PAGE_LIMIT = 10;

export const useInfiniteAchievementPosts = (
  entityId: string | null,
  achievementId: string | null,
  limit: number = ACHIEVEMENT_POSTS_PAGE_LIMIT
) => {
  return useInfiniteQuery<AchievementPostsResponse, Error>({
    queryKey: [...entityKeys.achievementPosts(entityId!, achievementId!), "infinite", { limit }],
    queryFn: ({ pageParam = 0 }) => getAchievementPosts(entityId!, achievementId!, limit, pageParam as number),
    getNextPageParam: (lastPage, allPages) => {
      const totalFetched = allPages.length * limit;
      return lastPage.data.items.length === limit ? totalFetched : undefined;
    },
    initialPageParam: 0,
    enabled: !!entityId && !!achievementId,
  });
};
